import * as Util from '../util/utilities'

export default {
    init() {
        const scrollcontrol = new ScrollMagic.Controller()
        const windowHalfX = window.innerHeight / 2

        if ($('[data-stacked]').length) {
            $('[data-stacked]').each(function () {
                const content = $(this).find('[data-content]')
                const graphic = $(this).find('[data-background]')

                Util.addAnimations(
                    [
                        TweenMax.fromTo(
                            content,
                            2,
                            {
                                y: '32%',
                            },
                            {
                                y: '-25%',
                                ease: Linear.easeNone,
                            },
                        ),
                        TweenMax.fromTo(
                            graphic,
                            2,
                            {
                                y: '-20%',
                            },
                            {
                                y: '12%',
                                ease: Linear.easeNone,
                            },
                        ),
                    ],
                    this,
                    '',
                    -windowHalfX,
                    '200%',
                    scrollcontrol,
                )
            })
        }
    },
}
